import Styled from "styled-components";
import { color, fontSize } from "style/constants";

export const StyledH1 = Styled.h1`
  font-size: ${fontSize.large}
  font-weight: normal;
`;

export const StyledH2 = Styled.h2`
  font-size: ${fontSize.normal}
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
`;

export const StyledP = Styled.p`
  color: ${color.DARKERGRAY}
  font-size: ${fontSize.small}
  font-style: normal;
  font-weight: normal;
  line-height: 15px;
  margin-bottom: 0.75rem;
`;

export const StyledSpan = Styled.span`
  font-size: ${fontSize.normal}
  font-style: normal;
  font-weight: 600;
`;
